import * as React from 'react';
import { Box, Button, TextField, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { createStoragePlanAsync } from '../AkademySlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflowY: 'scroll',
};

const CreatePlan = ({ apiCall, onClose }) => {
  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [priceINR, setPriceINR] = React.useState('');
  const [priceUSD, setPriceUSD] = React.useState('');
  const [sizeInGb, setSizeInGb] = React.useState('');
  const [durationInMonths, setDurationInMonths] = React.useState('');

  const dispatch = useDispatch();
  const handleCreatePlan = async () => {
    let payload = {
      name: name,
      description: description,
      price: [
        { amount: +priceINR, currency: 'INR' },
        { amount: +priceUSD, currency: 'USD' },
      ],
      sizeInGb: +sizeInGb,
      durationInMonths,
    };

    dispatch(createStoragePlanAsync(payload))
      .unwrap()
      .then((res) => {
        toast.success(`Plan has been created successully!`);
        onClose();
        apiCall();
      })
      .catch((err) =>
        toast.error('Something went wrong. please try again later')
      );
  };

  return (
    <Box sx={style}>
      <Box>
        <Typography>Add Storage Plan</Typography>
        <Box alignItems="center">
          <Box my={2}>
            <TextField
              required
              label="Name"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
              size="small"
              fullWidth
            />
          </Box>

          <Box my={2} display="flex" alignItems="center">
            <TextField
              required
              label="Description"
              variant="outlined"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              size="small"
              fullWidth
            />
          </Box>

          <Box my={2} display="flex" alignItems="center">
            <TextField
              required
              label="Price in Rupee"
              fullWidth
              size="small"
              type="number"
              variant="outlined"
              value={priceINR}
              onChange={(e) => setPriceINR(e.target.value)}
            />
          </Box>
          <Box my={2} display="flex" alignItems="center">
            <TextField
              required
              label="Price in Dollar"
              fullWidth
              size="small"
              type="number"
              variant="outlined"
              value={priceUSD}
              onChange={(e) => setPriceUSD(e.target.value)}
            />
          </Box>
          <Box my={2} display="flex" alignItems="center">
            <TextField
              required
              label="sizeInGb"
              fullWidth
              size="small"
              variant="outlined"
              type="number"
              value={sizeInGb}
              onChange={(e) => setSizeInGb(e.target.value)}
            />
          </Box>
          <Box my={2} display="flex" alignItems="center">
            <TextField
              required
              label="Duration (in months)"
              fullWidth
              size="small"
              variant="outlined"
              type="number"
              value={durationInMonths}
              onChange={(e) => setDurationInMonths(parseInt(e.target.value))}
            />
          </Box>
        </Box>
        <Box my={2}>
          <Button
            variant="contained"
            color="primary"
            disabled={
              name === '' ||
              description === '' ||
              priceUSD === '' ||
              priceINR === '' ||
              sizeInGb === ''
                ? true
                : false
            }
            onClick={() => handleCreatePlan()}>
            Add Plan
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CreatePlan;
